<template>
  <div class="template" v-if="isValidPage">
    <a-button
      class="button"
      type="primary"
      :disabled="isDisabled"
      :loading="loading"
      @click="handleLogin"
    >
      Continuar
    </a-button>
  </div>

  <h1 v-else>No user credentials</h1>
</template>

<script setup>
import { onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { message } from "ant-design-vue";

import { loadFacebook } from "@/app/shared/utils/loadFacebook";
import { tokenManager } from "@/app/shared/utils/tokenManager";
import httpManager from "@/app/shared/utils/httpManager";

const route = useRoute();
const store = useStore();

const accessToken = route.query.access_token;
const workspace = route.query.workspace;
const userId = route.query.userId;
const userFullname = route.query.userFullname;
const isValidPage = accessToken && workspace;
const tenantUrl =
  window.location.hostname == "localhost"
    ? "https://localhost:8080"
    : `https://${workspace}.${import.meta.env.VITE_HOSTNAME}`;

loadFacebook();

const loading = ref(false);
const isDisabled = ref(true);

if (isValidPage) {
  tokenManager.saveToken(accessToken);
  httpManager.updateBaseURL(`https://${workspace}.backend.${import.meta.env.VITE_HOSTNAME}`);
} else {
  message.error(
    "No es posible iniciar el proceso de vinculacion con Instagram, por favor intente nuevamente."
  );
}

const listener = (event) => {
  console.log(event);
  if (event.origin !== tenantUrl) return;
  if (event.data === "toggleDisable") isDisabled.value = !isDisabled.value;
};

window.addEventListener("message", listener);

onUnmounted(() => {
  window.removeEventListener("message", listener, false);
});

const handleLogin = async () => {
  try {
    loading.value = true;
    await store.dispatch("loginWithInstagram", {
      id: userId,
      fullname: userFullname,
    });
    // message.success("Logueado correctamente");
    window.parent.postMessage("success", tenantUrl);
  } catch (error) {
    const errorMessage = error?.message || "Algo salió mal, por favor vuelve a intentarlo";
    // message.warning(errorMessage);
    console.log({ errorMessage });

    window.parent.postMessage("error", tenantUrl);

    if (error?.error) console.log(error?.error);
  }

  loading.value = false;
};
</script>

<style lang="sass" scoped>
.template
  height: 100vh
  width: 100vw
  display: grid
  place-content: center

.button
  width: 40vw
</style>
